import { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";

import { LoadingCircle } from "@industriousoffice/react-components";

import { authApi } from "../../api/auth/authApi";

// all the pages that require to be logged in will be children of this component
// @see src/router
export function PrivateSection() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [canAccessBP, setCanAccessBP] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    authApi
      .getCognitoUser()
      .then((user) => {
        setIsLoggedIn(true);
        setCanAccessBP(!!user.claims.clientAccess?.canAccessBillingPortal);
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
      })
      .finally(() => setIsLoading(false));
  }, []);

  if (isLoading) return <LoadingCircle spinnerColor="#013e3f" />;

  if (!isLoggedIn) {
    if (import.meta.env.VITE_ENABLE_LOGIN_PAGE === "true") {
      return (
        <div className="p-2">
          not logged in, locally, use{" "}
          <Link to="/login">the login page to login</Link>
        </div>
      );
    }

    document.location.href = import.meta.env.VITE_MEMBER_PORTAL_URL || "/";
    return <LoadingCircle spinnerColor="#013e3f" />;
  }

  if (!canAccessBP) {
    document.location.href = import.meta.env.VITE_MEMBER_PORTAL_URL || "/";
    return <LoadingCircle spinnerColor="#013e3f" />;
  }

  return <Outlet />;
}
